/** Public AIRI Flux page. */
export const AIRI_FLUX_URL = '/settings/flux'

/** AIRI terms of service. */
export const AIRI_TERMS_URL = 'https://airi.moeru.ai/docs/en/about/terms'

/** AIRI privacy policy. */
export const AIRI_PRIVACY_URL = 'https://airi.moeru.ai/docs/en/about/privacy'
